export default __webpack_public_path__ + "static/media/Fantom Sonata.0d83388f.png";